// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DefaultTheme__modal-body___26GPu {
  position: relative;
  padding: 30px;
  overflow-y: auto;
  border-radius: 0;
  color: var(--_apc-modal-body-color, var(--steel4));
}

@media all and (-ms-high-contrast: none) { /* IE11 */
  *::-ms-backdrop,
  .DefaultTheme__modal-body___26GPu {
    max-height: calc(100vh - 341px); /* 100vh - (header + footer + 200px) */
  }
}
`, "",{"version":3,"sources":["webpack://./../node_modules/@mulesoft/anypoint-components/raw/components/ModalBody/themes/DefaultTheme.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,kDAAkD;AACpD;;AAEA,2CAA2C,SAAS;EAClD;;IAEE,+BAA+B,EAAE,sCAAsC;EACzE;AACF","sourcesContent":[".DefaultTheme__modal-body___26GPu {\n  position: relative;\n  padding: 30px;\n  overflow-y: auto;\n  border-radius: 0;\n  color: var(--_apc-modal-body-color, var(--steel4));\n}\n\n@media all and (-ms-high-contrast: none) { /* IE11 */\n  *::-ms-backdrop,\n  .DefaultTheme__modal-body___26GPu {\n    max-height: calc(100vh - 341px); /* 100vh - (header + footer + 200px) */\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
